





















import Vue from 'vue'
import Component from 'vue-class-component'
import { StringMap } from '../utils/map'
import { loggerFor } from '../utils/logger'
import RespondecoDialog from '@/main/dialog.vue'
import RespondecoDialogButtons from '@/main/dialog-buttons.vue'
import RespondecoDialogButton from '@/main/dialog-button.vue'

@Component({
  name: 'confirmation-dialog',
  components: { RespondecoDialogButton, RespondecoDialogButtons, RespondecoDialog },
})
export default class ConfirmationDialog extends Vue {
  public static dialogName = 'confirmation-dialog'

  public cancel!: () => void
  public ok!: () => void
  public text = 'common.dialog.confirmRemoval'
  public title = 'common.dialog.title.confirmRemoval'

  private logger = loggerFor('ConfirmationDialog')

  public beforeOpen(event: StringMap<any>): void {
    this.logger.debug('Opening confirmation dialog')

    this.cancel = event.params.cancel
    this.ok = event.params.ok

    if (event.params.text) {
      this.text = event.params.text
    }

    if (event.params.title) {
      this.title = event.params.title
    }
  }
}
